import support from './support.js';
export default {
  Login(uniform, account, password, company) {
    return support.post("Login/Login", {
      uniform: uniform,
      account: account,
      password: password,
      company: company
    });
  },
  checkLogin(company) {
    return support.post("Login/checkLogin", {
      company: company
    });
  }
}
